import { AutomationsAlias, InputsAlias, OutputsAlias } from 'src/app/model/automations-alias';

export const RBE_STATE_HIGH_KEY = '{RBE_STATE_HIGH}';
export const RBE_STATE_LOW_KEY = '{RBE_STATE_LOW}';

export type RbeIoStateAliasLike = {
	StateOn?: string;
	StateOff?: string;
	DefaultStateOn?: string;
	DefaultStateOff?: string;
};

function firstNonEmpty(...values: (string | undefined | null)[]): string | undefined {
	for (const value of values) {
		if (value !== undefined && value !== null && String(value).trim() !== '') {
			return String(value);
		}
	}
	return undefined;
}

export function pickRbeIoStateRaw(isHigh: boolean, alias?: RbeIoStateAliasLike | null): string {
	if (isHigh) {
		return firstNonEmpty(alias?.StateOn, alias?.DefaultStateOn) ?? RBE_STATE_HIGH_KEY;
	}
	return firstNonEmpty(alias?.StateOff, alias?.DefaultStateOff) ?? RBE_STATE_LOW_KEY;
}

export function rawIfUnchanged(
	edited: string,
	currentRaw: string | undefined,
	defaultRaw: string | undefined,
	translateData: (s: string) => string
): string {
	if (defaultRaw !== undefined && defaultRaw !== '' && edited === translateData(defaultRaw)) {
		return defaultRaw;
	}
	if (currentRaw !== undefined && currentRaw !== '' && edited === translateData(currentRaw)) {
		return currentRaw;
	}
	return edited;
}

function stripDefaults<T extends InputsAlias | OutputsAlias>(item: T): T {
	return {
		...item,
		DefaultDescription: undefined,
		DefaultStateOn: undefined,
		DefaultStateOff: undefined
	};
}

export function buildRbeIoStateAliasPatch(
	kind: 'input' | 'output',
	items: InputsAlias[] | OutputsAlias[],
	targetId: number,
	stateOnEdited: string,
	stateOffEdited: string,
	translateData: (s: string) => string
): AutomationsAlias {
	const mapped = items.map(item => {
		if (item.Id !== targetId) {
			return stripDefaults({ ...item });
		}
		const next = { ...item };
		next.StateOn = rawIfUnchanged(stateOnEdited, item.StateOn, item.DefaultStateOn, translateData);
		next.StateOff = rawIfUnchanged(stateOffEdited, item.StateOff, item.DefaultStateOff, translateData);
		return stripDefaults(next);
	});
	const result = new AutomationsAlias();
	if (kind === 'input') {
		result.Inputs = mapped as InputsAlias[];
	} else {
		result.Outputs = mapped as OutputsAlias[];
	}
	return result;
}
